import React from 'react'
import PropTypes from 'prop-types'
import { withResponsive } from '../../Grid'
import FullScreenViewport from './FullScreenViewport'
import SidebarViewport from './SidebarViewport'
import { EducationFeature } from 'education-tools'
import ErrorBoundary from '../ErrorBoundary'
import FreshChatWidget from '../../FreshChatWidget'

Viewport.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isTablet: PropTypes.bool.isRequired
}

function Viewport({ isMobile, isTablet }) {
  return (
    <ErrorBoundary>
      <EducationFeature name="meg.uhqm">
        {isMobile || isTablet ? <FullScreenViewport /> : <SidebarViewport />}
        <FreshChatWidget />
      </EducationFeature>
    </ErrorBoundary>
  )
}

export default withResponsive(Viewport)
